module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc",
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_vm._v("Copyright ")]), _c('span', {
    staticClass: "toc"
  }, [_vm._v("© 2019 Karen")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Arrington.")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Published by The Tiny Press, an imprint of Mango Publishing Group, a division of Mango Media")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }, [_vm._v("Front Cover design by Joanna Price  |  joannapricedesign.com")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }, [_vm._v("Cover illustration: Jag_cz/Shutterstock ")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Layout & Design: Roberto")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Núñez")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Mango is an active supporter of authors’ rights to free speech and artistic expression in their books.  The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("society.")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property.  Please honor the author’s work as you would your own. Thank you in advance for respecting our author’s")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("For permission requests, please contact the publisher")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("at:")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Mango Publishing")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Group")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("2850 S Douglas Road, 2nd")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Floor")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Coral Gables, FL 33134")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("USA")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@mango.bz"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("info@mango.bz")])]), _c('span', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at ")]), _c('a', {
    attrs: {
      "href": "mailto:sales@mango.bz"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("sales@mango.bz")])]), _c('span', {
    staticClass: "toc"
  }, [_vm._v(".  For trade and wholesale sales, please contact Ingram Publisher Services at ")]), _c('a', {
    attrs: {
      "href": "mailto:customer.service@ingramcontent.com"
    }
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("customer.service@ingramcontent.com")])]), _c('span', {
    staticClass: "toc"
  }, [_vm._v(" or +1.800.509.4887.")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Your Next Level Life: 7 Rules of Power, Confidence, and Opportunity for Black Women in")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("America")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication number: #######")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }, [_vm._v("ISBN: (print) 978-1-64250-032-5, (ebook) 978-1-64250-031-8")]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("BISAC category code: SOC010000, SOCIAL SCIENCE / Feminism & Feminist")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CopyrightPage"
  }, [_c('span', {
    staticClass: "toc"
  }, [_vm._v("Printed in the United States of")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "toc"
  }, [_vm._v("America")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8b6372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/YourNextLevelLife_split_002.vue
// module id = 63
// module chunks = 0